var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initDone)?_c('div',[(_vm.$store.state.device.isPC)?[_c('HeaderPC')]:[_c('HeaderWAP')],_c('router-view'),(_vm.$store.state.device.isPC)?[_c('FooterPC'),_c('SliderBar')]:[_c('FooterWAP')]],2):_c('div',{staticClass:"loading-screen"})
}
var staticRenderFns = []

export { render, staticRenderFns }